import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState, EnrolledExam } from '.';

const selectSlice = (state: RootState) =>
  state.examStore || initialState;

export const selectExamStore = createSelector(
  [selectSlice],
  state => state,
);

export const selectEnrolledExams = createSelector(
  [selectSlice],
  state => state.enrolledExams,
);

export const selectIsExamEnrolled = (examId: string) => 
 {

  return  createSelector(
    [selectEnrolledExams],
    (enrolledExams: EnrolledExam[] | undefined) => 
      enrolledExams ? enrolledExams.some(exam => exam.examId === examId) : false
  );
 }
